import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { adminApi, getToken } from "@/lib/adminApi";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function Admin() {
  const [authed, setAuthed] = useState(null); // null = checking

  useEffect(() => {
    if (!getToken()) { setAuthed(false); return; }
    adminApi.verify().then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);

  if (authed === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-ink text-amber">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  return authed ? (
    <AdminDashboard onLogout={() => setAuthed(false)} />
  ) : (
    <AdminLogin onAuthed={() => setAuthed(true)} />
  );
}
